<tui-preview [initialScale]="0.9" [rotatable]="true">
  <tui-preview-title *ngIf="!!data?.title">{{ data?.title }}</tui-preview-title>

  <button iconStart="@tui.x" tuiIconButton tuiPreviewAction type="button" (click)="cancel()">Закрыть</button>

  <img [tuiSkeleton]="loading" alt="image" [src]="photoSrc | safe: 'resourceUrl'" />
</tui-preview>
